<template>
  <div class="card">
    <survey-details></survey-details>
  </div>
</template>
<script>
import SurveyDetails from './SurveyDetails'
import QuestionDetails from './QuestionDetails'
import FinalizeSurvey from './FinalizeSurvey'
export default {
  components: {
    SurveyDetails,
    QuestionDetails,
    FinalizeSurvey
  },
  data () {
    return {
      active: 1,
      surveyDetails: '',
      validation: ''
    }
  },
  methods: {
    clickNext () {
      if (this.active < 3) {
        this.active++
      }
    },
    clickPrev () {
      if (this.active > 1) {
        this.active--
      }
    },
    stepNext (data) {
      this.surveyDetails = data.event
      if (this.active < 3) {
        this.active++
      }
    }
  }
}
</script>
<style scoped>
.surveyPrev {
  /* margin-right: 70%; */
}
.surveyNext {
  margin-left: 75%;
}
/* .el-step__head.is-finish {
  color: #1C2B36;
  border-color: #1C2B36;
}
.el-step__description.is-finish {
  color: #1C2B36;
}
.el-step__title.is-finish {
  color: #1C2B36;
}
.el-step__head.is-process {
  color: #209e91;
  border-color: #209e91;
}
.el-step__line {
  background-color: #209e91;
}
.el-step__head.is-wait {
  color: #209e91;
  border-color: #209e91;
} */
</style>



// WEBPACK FOOTER //
// src/components/Survey/CreateSurvey.vue